import Axios from 'axios'

const apiEndpoint = 'operation/api/v1/operation-indices'

const store = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {}
}

store.actions.FETCH_ALL = function() {
    return Axios.get(apiEndpoint)
        .then(response => response.data);
}

store.actions.DELETE = function({}, {id}) {
    return Axios.delete(`${apiEndpoint}/${id}`);
}

store.actions.SAVE = async function({}, {id, fields, operationDefinition}) {
    if(id) throw "Not supported";
    if(!(fields && fields.length > 0 && operationDefinition)) throw "Invalid object";
    const toSave = {operationDefinition, fields};
    const createdUri = (await Axios.post(`${apiEndpoint}`, toSave)).headers.location;
    return (await Axios.get(createdUri)).data;

}
export default store;